/**
 * Guided Fix Days — "is the week actually on track?" for the Finish action.
 *
 * Finishing Fix Days used to always toast "Your week is now on track",
 * whatever the days really looked like. Finish now re-fetches the planning
 * summary for the week and only makes that claim when this returns true;
 * otherwise it uses neutral completion wording.
 *
 * Mirrors PlanningHub.renderWeeklyOverview's own `allAligned` rule exactly
 * (the rule behind its "You're on track this week" headline):
 *   - remaining days = today onward within the week (all 7 when today isn't
 *     in the week, i.e. a past or future week);
 *   - nutrition targets must be real/complete (`targets_ready`);
 *   - every remaining day must have at least one planned row;
 *   - every remaining day's summed macros must classify as 'on-track' via the
 *     shared goal-aware getMacroStatus.
 */
import { getMacroStatus } from './macroStatus';

export function isWeekOnTrack(summary, weekDates, todayStr) {
  if (!summary || !summary.targets_ready || !summary.daily_goal) return false;
  var dates = weekDates || [];
  var mealsByDate = summary.meals_by_date || {};

  var remaining = [];
  var seenToday = false;
  for (var i = 0; i < dates.length; i++) {
    if (dates[i] === todayStr) seenToday = true;
    if (seenToday) remaining.push(dates[i]);
  }
  if (remaining.length === 0) remaining = dates.slice();
  if (remaining.length === 0) return false;

  for (var d = 0; d < remaining.length; d++) {
    var dayMeals = mealsByDate[remaining[d]] || [];
    if (dayMeals.length === 0) return false;
    var totals = { calories: 0, protein: 0, carbs: 0, fat: 0 };
    for (var m = 0; m < dayMeals.length; m++) {
      var macros = dayMeals[m].macros || {};
      totals.calories += macros.calories || 0;
      totals.protein += macros.protein || 0;
      totals.carbs += macros.carbs || 0;
      totals.fat += macros.fat || 0;
    }
    if (getMacroStatus(totals, summary.daily_goal, summary.goal) !== 'on-track') return false;
  }
  return true;
}
